import { Height } from '@mui/icons-material'
import React, { useEffect } from 'react'

const Constitution = () => {
    const url = window.location;
    console.log(url);

    useEffect(() => {
      document.title = 'Staffs HandBook | TASTE PLACE INVESTMENT'
    }, [])
  return (
    <div className=' container card my-5 px-4'
    style={{ 
        height: `${window.innerWidth > 667 ? '85vh' : '60vh'}`
     }}
    >
        <h2 className='small-header ms-4 mt-4 text-center'>TASTE PLACE INVESTMENT Staff HandBook.</h2>
        <div 
        className='py-3'
        style={{ 
            height: `${window.innerWidth > 667 ? '85vh' : '60vh'}`
         }}>
            <iframe title='handbook'
            src="https://docs.google.com/gview?url=https://tasteplace.com.ng/tpi/assets/files/staffs_handbook.pdf&embedded=true"
            // src='./staffs_handbook.pdf'
            width={'100%'} 
            height='99%'
            />
        </div>
    </div>
  )
}

export default Constitution